<script setup lang="ts">
import { computed } from 'vue'

import AffiliateInfo from '../shared/AffiliateInfo.vue'
import { hashString } from '../../utils/strings'

import type { AffiliateLinkParagraph } from '../../utils/paragraph-schema/paragraphs'

const props = withDefaults(defineProps<{
  affiliateLink: AffiliateLinkParagraph['affiliateLink'],
  isImageOverlay?: boolean
}>(), {
  isImageOverlay: false
})

const uniqueId = computed(() => hashString(props.affiliateLink?.url ?? ''))
</script>

<template>
  <div v-if="affiliateLink?.title && affiliateLink?.buttonText"
       class="bx-affiliate-link bx-typo--product-group"
       :class="{
         'bx-content': !isImageOverlay,
         'bx-affiliate-link--with-badge': affiliateLink?.showAffiliateBadge,
         'bx-affiliate-link--highlight': affiliateLink?.highlighted
       }"
       data-tc="affiliate-link">
    <div class="bx-affiliate-link__wrapper">
      <AffiliateInfo v-if="affiliateLink?.showAffiliateBadge"
                     affiliate-type="affiliate-link" />
      <a :href="affiliateLink?.url || '#'"
         :rel="affiliateLink?.rel"
         :target="affiliateLink?.target"
         :title="affiliateLink?.title"
         data-ga-coco-group-type="affiliateLink"
         :data-ga-coco-unique-id="uniqueId"
         data-tc="affiliate-link-url">
        <div class="bx-affiliate-link__title bx-typo--content-interline"
             data-tc="affiliate-link-title">
          {{ affiliateLink?.title }}
        </div>
        <div v-if="affiliateLink?.subtitle"
             class="bx-affiliate-link__subtitle"
             data-tc="affiliate-link-subtitle">
          {{ affiliateLink?.subtitle }}
        </div>
        <div class="bx-button-group bx-button-group--highlight bx-typo--button-group">
          <div class="bx-button"
               data-tc="affiliate-link-button">
            <span>{{ affiliateLink?.buttonText }}</span>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>
